export const storageKeys = {
  deviceId: 'deviceId',
} as const;
